const color = {
  // Basic Colors
  white: '#FFFFFF',
  white2: '#F8F8F8',
  black: '#000000',
  black2: '#0C0C0C',
  navyLight: '#05054C',
  navyDark: '#020322',
  // BG Colors
  lightMode: '#FFFFFF',
  darkMode: '#1E1E20',
  grayBg: '#C4C4C4',

  // Primary Colors
  blue: '#66B6FF',
  blue50: '#E3F2FF',
  blue100: '#BCDEFF',
  blue200: '#92CAFF',
  blue300: '#66B6FF',
  blue400: '#46A5FF',
  blue500: '#3195FD',
  blue600: '#3187EE',
  blue700: '#2E75DA',
  blue800: '#2D63C7',
  blue900: '#2944A7',

  // Secondary Colors
  aqua: '#A7FFEF',
  aqua50: '#DDFFFA',
  aqua100: '#A7FFEF',
  aqua200: '#75FDE5',
  aqua300: '#48F7D8',
  aqua400: '#22EECC',
  aqua500: '#18E7C1',
  aqua600: '#10d6b1',
  aqua700: '#0bc39e',
  aqua800: '#08b28e',
  aqua900: '#0f926f',

  // Optional Colors
  azure: '#34C2FF',
  green: '#10DB9E',
  red: '#FF3737',
  orange: '#FE7C04',
  navy: '#264A9F',
  lime: '#89FF66',
  yellow: '#FFE766',

  // Gray Colors
  gray50: '#FAFAFA',
  gray100: '#F5F5F5',
  gray200: '#EEEEEE',
  gray300: '#E0E0E0',
  gray400: '#BDBDBD',
  gray500: '#9E9E9E',
  gray600: '#757575',
  gray700: '#616161',
  gray800: '#424242',
  gray900: '#212121',

  // Opacity Colors
  opacityWhite005: 'rgba(255, 255, 255, 0.05)',
  opacityWhite01: 'rgba(255, 255, 255, 0.1)',
  opacityWhite02: 'rgba(255, 255, 255, 0.2)',
  opacityWhite03: 'rgba(255, 255, 255, 0.3)',
  opacityWhite04: 'rgba(255, 255, 255, 0.4)',
  opacityWhite05: 'rgba(255, 255, 255, 0.5)',
  opacityWhite06: 'rgba(255, 255, 255, 0.6)',
  opacityWhite07: 'rgba(255, 255, 255, 0.7)',
  opacityWhite08: 'rgba(255, 255, 255,0.8)',
  opacityWhite09: 'rgba(255, 255, 255, 0.9)',

  opacityBlack005: 'rgba(0, 0, 0, 0.05)',
  opacityBlack01: 'rgba(0, 0, 0, 0.1)',
  opacityBlack02: 'rgba(0, 0, 0, 0.2)',
  opacityBlack03: 'rgba(0, 0, 0, 0.3)',
  opacityBlack04: 'rgba(0, 0, 0, 0.4)',
  opacityBlack05: 'rgba(0, 0, 0, 0.5)',
  opacityBlack06: 'rgba(0, 0, 0, 0.6)',
  opacityBlack07: 'rgba(0, 0, 0, 0.7)',
  opacityBlack08: 'rgba(0, 0, 0, 0.8)',
  opacityBlack09: 'rgba(0, 0, 0, 0.9)',

  opacityBlue01: 'rgba(102, 182, 255, 0.1)',
  opacityBlue05: 'rgba(102, 182, 255, 0.5)',

  // Graph Colors
  graphRed: '#F23036',
  graphOrange: '#FFA620',
  graphYellow: '#FBFF31',
  graphGreen: '#53D63E',
  graphBlue: '#1055F8',
  graphViolet: '#971489',
  graphPink: '#F300AF',

  // Gradient Colors
  gradientType1: 'linear-gradient(270deg, #84FFE9 0%, #ACAAFF 100%)'
};

export { color };
